<!-- eslint-disable -->
<script setup>
import { ref } from 'vue';
import { useCustomerStore } from '@/stores/customer';
import { useCurrenciesStore } from '@/stores/currencies';
import { useBonusStore } from '@/stores/bonus';
import { useLoginStore } from '@/stores/login';
import { openModal } from '@kolirt/vue-modal';
import headerIcons from '@/assets/svgs/Header.json';
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import VerificationEmail from '../modals/VerificationEmail.vue';
import { useI18n } from 'vue-i18n';
import Swal from 'sweetalert2';
import { useRouter } from 'vue-router';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { useAgentStore } from '@/stores/agent';

const router = useRouter();
const customerStore = useCustomerStore();
const currenciesStore = useCurrenciesStore();
const bonusStore = useBonusStore();
const loginStore = useLoginStore();
const { t } = useI18n();
const header_icons = headerIcons;
const svgs_data = commonSvgs;
const tab_active = ref('account');
const loading = ref(false);
const active_bonus = ref(null);
const refresh_balance = ref(false);
const active_bonus_id = ref(null);
const platformConfigurationStore = usePlatformConfigurationStore();
const agentStore = useAgentStore();

const claimBonus = (bonus_id) => {
	loading.value = true;
	let payload = { bonus_id: bonus_id };

	if (!customerStore.hasVerifiedEmail) {
		openModal(VerificationEmail);
		loading.value = false;
		return;
	}

	bonusStore.claimManualBonus(payload).then(() => {
		bonusStore.fetchOffers();
		fireSwal('success', t('general.claim_bonus'));
		loading.value = false;
	}).catch((error) => {
		fireSwal('error', error.data.message);
		loading.value = false;
	});
}

const refreshBalance = () => {
	refresh_balance.value = true

	customerStore.fetchBalance().then(() => {
		refresh_balance.value = false;
	}).catch((error) => {
		refresh_balance.value = false;
	})
}

const cancelBonus = (bonus_id) => {
	loading.value = true;
	let payload = { bonus_id: bonus_id };

	active_bonus_id.value = null;

	bonusStore.cancelCustomerBonus(payload.bonus_id).then(() => {
		fireSwal('success', t('general.cancel_bonus'));
		loading.value = false;
		bonusStore.fetchOffers();
	}).catch((error) => {
		fireSwal('error', error.data.message);
		loading.value = false;
	});
}

const goToDeposit = (deposit_bonus) => {
	if (deposit_bonus != null) router.push({ name: 'bank-deposits', query: { bonus_id: deposit_bonus.id } });
	else router.push({ name: 'bank-deposits' })
}

const cancelBonusVerification = (id) => {
	active_bonus_id.value = id
	confirmCancelSwal();
}

const logout = () => {
	loginStore.logout()
};

const toggleBalanceVisibility = () => {
	if (customerStore.balance_visibility == true) customerStore.balance_visibility = false;
	else customerStore.balance_visibility = true;
};

const fireSwal = (alert_type, alert_message) => {
	Swal.fire({
		text: alert_message,
		icon: alert_type,
		confirmButtonText: alert_type == 'success' ? t('account.register.close') : t('general.try_again'),
	});
}

const confirmCancelSwal = () => {
	Swal.fire({
		text: t('general.cancel_bonus_text'),
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: t('general.yes'),
		cancelButtonText: t('general.no'),
	}).then((result) => {
		if (result.isConfirmed) {
			cancelBonus(active_bonus_id.value);
		}
	});
}
</script>
<template>
	<div class="user-dropdown-info">
		<div class="user-amount-info">
			<div class="user-amount-inner">
				<span>{{ $t('general.withdrawable') }}</span>
				<h6 v-if="customerStore.balance_visibility == true">{{ currenciesStore.format_currency(customerStore.getCustomer.balance.withdrawable, customerStore.getCustomer.currency.code) }}</h6>
				<h6 v-else>********</h6>
			</div>
			<div class="user-amount-inner">
				<span>{{ $t('general.bet_credits') }}</span>
				<h6 v-if="customerStore.balance_visibility == true">{{ currenciesStore.format_currency(customerStore.getCustomer.balance.bonus_balance, customerStore.getCustomer.currency.code) }}</h6>
				<h6 v-else>********</h6>
			</div>
			<div class="balance-container">
				<span class="mobile-only" v-if="customerStore.balance_visibility == true">
				<svg @click="toggleBalanceVisibility()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--white)" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye">
					<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
					<circle cx="12" cy="12" r="3"></circle></svg>
				</span>
				<span class="mobile-only" v-else>
					<svg  @click="toggleBalanceVisibility()" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
						<g id="Icon_feather-eye-off" data-name="Icon feather-eye-off" transform="translate(-0.793 2.207)">
							<path id="Path_266" data-name="Path 266" fill="none" stroke="var(--white)" d="M12.28,14.846A6.42,6.42,0,0,1,8.5,16.153c-4.455,0-7-5.077-7-5.077A11.717,11.717,0,0,1,4.72,7.307M7.164,6.152A5.819,5.819,0,0,1,8.5,6c4.455,0,7,5.077,7,5.077A11.738,11.738,0,0,1,14.125,13.1m-4.276-.679a1.907,1.907,0,1,1-2.7-2.691" transform="translate(0 -2.577)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
							<path id="Path_267" data-name="Path 267" d="M1.5,1.5l14,14" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
						</g>
					</svg>
				</span>
			<a @click="refreshBalance" class="dropdown-eye-icon">
				<a>
					<svg :class="{ 'rotate-svg': refresh_balance }" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 30 30"
						style="fill:var(--white);">
						<path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
					</svg>
				</a>
			</a>
			</div>
			<div v-if="!agentStore.isAgentOrAffiliate" class="user-amount-btn">
				<router-link to="/account/bank/deposits" class="btn btn-secondary">{{ $t('general.deposit') }}</router-link>
			</div>
		</div>

		<div class="user-dropdown-tabs offer-tab-active">
			<div class="tab">
				<button class="tablinks" :class="tab_active=='account' ? 'active' : ''" @click=" tab_active = 'account'">{{ $t('general.my_account') }}</button>
				<button class="tablinks" :class="tab_active=='offers' ? 'active' : ''" @click=" tab_active = 'offers'">{{ $t('general.my_offers') }}</button>
			</div>

			<!-- my account content area -->
			<div class="tab-content" :class="tab_active == 'account'? 'active': ''" >
				<div class="user-tab-content">
					<div class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.account"></div>
						</div>
						<router-link to="/account/account-details/preferences">
							<h6>{{ $t('general.account_preferences') }}</h6>
						</router-link>
					</div>

					<div v-if="!agentStore.isAgentOrAffiliate" class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.bank"></div>
						</div>
						<router-link to="/account/bank/deposits">
							<h6>{{ $t('general.bank') }}</h6>
						</router-link>
					</div>

					<div class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.history"></div>
						</div>
						<router-link to="/account/history/settled-bets">
							<h6>{{ $t('general.history') }}</h6>
						</router-link>
					</div>

					<div v-if="!agentStore.isAgentOrAffiliate" class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.player_protech"></div>
						</div>
						<router-link to="/account/player-protection/limits/login-limit">
							<h6>{{$t('account.customer_protection.customer_protection_title')}}</h6>
						</router-link>
					</div>

					<div class="user-tab-inner">
						<div class="tab-inner-icon" v-if="customerStore.getCustomer">
							<span class="notification-num" v-if="customerStore.getCustomer.unread_messages_count > 0">{{ customerStore.getCustomer.unread_messages_count }}</span>
							<div v-html="header_icons.message"></div>
						</div>
						<router-link to="/account/messages">
							<h6>{{ $t('general.messages') }}</h6>
						</router-link>
					</div>

					<div class="user-tab-inner">
						<div class="tab-inner-icon">
							<span class="notification-num" v-if="customerStore.unclaimed_bonuses_length > 0">{{ customerStore.unclaimed_bonuses_length }}</span>
							<div v-html="header_icons.bonus"></div>
						</div>
						<router-link to="/account/bonus/active-bonuses">
							<h6>{{ $t('general.bonus') }}</h6>
						</router-link>
					</div>

					<div v-if="platformConfigurationStore.isReferralEnabled && !agentStore.isAgentOrAffiliate" class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.referral"></div>
						</div>
						<router-link to="/account/account-referrals/dashboard">
							<h6>{{  $t('account.account_referrals.title') }}</h6>
						</router-link>
					</div>

					<div v-if="platformConfigurationStore.isBetInfluencerEnabled && !agentStore.isAgentOrAffiliate" class="user-tab-inner">
						<div class="tab-inner-icon">
							<div v-html="header_icons.bet_influencer"></div>
						</div>
						<router-link to="/account/bet-influencer">
							<h6>{{ $t('account.bet_influencer.title') }}</h6>
						</router-link>
					</div>

					<div v-if="agentStore.agentEnabled && agentStore.isCustomerAgent" class="user-tab-inner">
						<div class="tab-inner-icon">
							<svg width="22" height="22" viewBox="204 52 31 31" xmlns="http://www.w3.org/2000/svg">
								<path d="m 229.375,53.988287 c -0.72661,0.01749 -1.45694,0.210816 -2.12695,0.597646 -2.14404,1.237874 -2.8863,4.010272 -1.64844,6.1543 0.0207,0.03577 0.043,0.07045 0.0644,0.105515 l -5.31055,4.927737 c -1.49788,-1.113291 -3.35013,-1.77344 -5.35351,-1.773439 -0.56859,3e-6 -1.12432,0.05469 -1.66407,0.156248 l -1.65234,-3.916017 c 1.3276,-1.060458 1.72483,-2.979634 0.85156,-4.492182 -0.96177,-1.665843 -3.12126,-2.243027 -4.7871,-1.281252 -1.66585,0.96178 -2.24499,3.119311 -1.28321,4.785155 0.7021,1.216081 2.04281,1.853423 3.36328,1.734371 l 1.58594,3.761727 c -3.1815,1.389704 -5.41406,4.567013 -5.41406,8.251951 -1e-5,2.80419 1.29264,5.31434 3.31249,6.9668 a 1,1 0 0 0 0.48242,0.36523 c 1.47125,1.04807 3.26712,1.66797 5.20509,1.66797 2.00493,0 3.85893,-0.66054 5.35742,-1.7754 a 1,1 0 0 0 0.22849,-0.17776 c 0.87949,-0.69891 1.6249,-1.55794 2.19336,-2.5332 l 4.22266,0.96289 c -0.006,0.60475 0.14091,1.21771 0.46288,1.77538 0.96178,1.66586 3.12127,2.24303 4.78712,1.28125 1.66584,-0.96177 2.24498,-3.1193 1.2832,-4.78515 -0.96178,-1.66585 -3.12126,-2.24498 -4.78711,-1.2832 -0.48199,0.27828 -0.87119,0.65793 -1.16015,1.0957 l -3.98828,-0.91211 c 0.25897,-0.83794 0.40039,-1.72712 0.40039,-2.64844 -1e-5,-0.37052 -0.0245,-0.73477 -0.0684,-1.09375 l 3.53516,-0.62695 c 0.96204,1.6643 3.12008,2.24259 4.78516,1.28126 1.66585,-0.96178 2.24302,-3.121267 1.28124,-4.787119 -0.96177,-1.665843 -3.1193,-2.243028 -4.78515,-1.281248 -1.05446,0.608795 -1.67201,1.696523 -1.74023,2.835937 l -3.53906,0.628899 c -0.3756,-1.040572 -0.93808,-1.992921 -1.64649,-2.816402 l 5.24609,-4.869138 c 1.37462,0.877644 3.18154,0.984393 4.6836,0.117183 2.14403,-1.23786 2.88825,-4.008297 1.65038,-6.152342 -0.85102,-1.474019 -2.42878,-2.286537 -4.02734,-2.24804 z m 0.0606,1.990227 c 0.88719,-0.0251 1.7549,0.427341 2.23437,1.257816 0.69743,1.207976 0.29,2.7225 -0.91796,3.419915 -1.20798,0.697425 -2.7225,0.291968 -3.41993,-0.916008 -0.69742,-1.207966 -0.29195,-2.724452 0.91602,-3.421872 0.37749,-0.217945 0.78423,-0.328441 1.1875,-0.339851 z m -19.97266,0.01367 c 0.53276,-0.01671 1.05213,0.254143 1.3418,0.755866 0.42134,0.729783 0.17705,1.633346 -0.55274,2.054686 -0.72978,0.42134 -1.63334,0.179004 -2.05468,-0.550778 -0.42134,-0.729773 -0.179,-1.631396 0.55078,-2.052736 0.22806,-0.13167 0.47267,-0.199456 0.71484,-0.207038 z m 5.53711,10.007817 c 3.87784,4e-6 7,3.122164 7.00001,6.999997 -1e-5,1.77485 -0.65516,3.38974 -1.73633,4.6211 -0.61002,-1.111 -1.56136,-2.00863 -2.71094,-2.55078 0.88222,-0.73572 1.44726,-1.84076 1.44726,-3.07032 0,-2.197278 -1.80271,-4.000002 -4,-3.999997 -2.19728,4e-6 -4,1.802718 -4,3.999997 0,1.22956 0.56504,2.3346 1.44727,3.07031 -1.14939,0.54242 -2.10105,1.43958 -2.71094,2.55079 -1.08117,-1.23137 -1.73634,-2.84624 -1.73633,-4.62109 0,-3.877845 3.12216,-7.000006 7,-7.000007 z m 15.4629,2.017577 c 0.53226,-0.01642 1.05016,0.254136 1.33983,0.75586 0.42134,0.729782 0.17901,1.633344 -0.55078,2.05468 -0.72978,0.42134 -1.63334,0.17901 -2.05468,-0.550774 -0.42134,-0.729782 -0.17901,-1.633344 0.55078,-2.054684 0.22806,-0.13167 0.4729,-0.197629 0.71485,-0.205082 z M 215.00005,70 c 1.11642,-10e-7 2.00001,0.883588 2,1.999998 0,1.11642 -0.88358,2 -2,2 -1.11642,0 -2,-0.88358 -2,-2 1e-5,-1.11641 0.88358,-1.999997 2,-1.999998 z m 1e-5,6.500008 c 1.67074,-10e-6 3.08932,1.0143 3.6914,2.45507 -1.07046,0.66318 -2.33451,1.04492 -3.69141,1.04492 -1.3569,0 -2.62094,-0.38176 -3.6914,-1.04492 0.60203,-1.44072 2.0209,-2.45508 3.69141,-2.45507 z m 15.46289,0.49023 c 0.53225,-0.0164 1.05017,0.25608 1.33984,0.75781 0.42134,0.72978 0.17899,1.63335 -0.55078,2.05468 -0.72978,0.42134 -1.63336,0.17901 -2.0547,-0.55077 -0.42134,-0.72978 -0.17899,-1.63335 0.55079,-2.05469 0.22806,-0.13167 0.47289,-0.19959 0.71485,-0.20703 z" fill="var(--light-gray)" fill-rule="evenodd" />
							</svg>
						</div>
						<router-link to="/account/agent/customers">
							<h6>{{ $t('agent.agent') }}</h6>
						</router-link>
					</div>

				</div>
			</div>
			<!-- end -->
			<!-- my offer content area -->
			<div class="tab-content" :class="tab_active=='offers'? 'active': ''">
				<div class="my-offer-outer">
					<div class="offers-accordion">
						<div class="offers-empty" v-if="(!customerStore.availableBonuses?.length > 0 && !customerStore.activeBonuses?.length > 0)">
							<p>{{ $t('general.no_available_bonus') }}</p>
						</div>

						<div class="offers-accordion-inner" v-else v-for="(available_bonus, index) in customerStore.availableBonuses" :key="index" :class="active_bonus==index+'index'? 'active':''" @click="active_bonus==index+'index'? active_bonus = '': active_bonus = index+'index'">
							<div class="offers-top-header">
								<h3>{{ available_bonus.name }}</h3>
								<span v-html="svgs_data.dropdown_icon"></span>
							</div>
							<div class="offers-tab-content">
								<div class="offers-tab-main">
									<div class="offer-content-inner">
										<h4>{{ $t('account.affiliate.product') }}:</h4>
										<p>{{ available_bonus.products }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.minimum_deposit_amount') }}:</h4>
										<p>{{ currenciesStore.format_currency(available_bonus.min_deposit_amount, customerStore.customer.currency.code) }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.maximum_bonus_amount') }}:</h4>
										<p>{{ currenciesStore.format_currency(available_bonus.max_bonus_amount, customerStore.customer.currency.code) }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.deposit_bonus_percentage') }}:</h4>
										<p>{{ available_bonus.bonus_deposit_percentage }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.rollover_factor_deposit') }}:</h4>
										<p>{{ available_bonus.rollover_factor_deposit }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.rollover_factor_bonus') }}:</h4>
										<p>{{ available_bonus.rollover_factor_bonus }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.expiration_days') }}:</h4>
										<p>{{ available_bonus.expiration_days }}</p>
									</div>
								</div>
								<div class="user-amount-btn" v-if="available_bonus.is_deposit_bonus">
									<a v-if="!agentStore.isAgentOrAffiliate" @click="goToDeposit(available_bonus)" class="btn btn-secondary">{{ $t('account.affiliate.deposit') }}</a>
								</div>
								<div class="user-amount-btn" v-else>
									<button type="button" class="btn btn-secondary" v-if="!loading" @click="claimBonus(available_bonus.id)" style="cursor: pointer;">{{ $t('general.claim') }}</button>
									<button class="btn btn-secondary" type="button" v-else-if="loading"><div class="loader-main"></div></button>
								</div>
							</div>
						</div>

						<div class="offers-accordion-inner" v-show="customerStore.activeBonuses?.length > 0" v-for="(bonus, index) in customerStore.activeBonuses" :key="index" :class="active_bonus==index+'index'? 'active':''" @click="active_bonus==index+'index'? active_bonus = '': active_bonus = index+'index'">
							<div class="offers-top-header">
								<h3>{{bonus.name}}</h3>
								<span v-html="svgs_data.dropdown_icon"></span>
							</div>
							<div class="offers-top-header">
								<h3>{{ $t('general.progress') }}:</h3>
								<div class="main-progress-bar">
									<progress :value="bonus.stake_current * 100 / bonus.stake_target" max="100" class="main-progress-bar"></progress>
								</div>
							</div>
							<div class="offers-tab-content">
								<div class="offers-tab-main">
									<div class="offer-content-inner">
										<h4>{{ $t('general.bonus_description') }}:</h4>
										<p>{{ bonus.short_description }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.bonus_amount') }}:</h4>
										<p>{{ currenciesStore.format_currency(bonus.bonus_amount, customerStore.customer.currency.code) }}</p>
									</div>
									<div class="offer-content-inner">
										<h4>{{ $t('general.expires_at') }}:</h4>
										<p>{{ bonus.expires_at }}</p>
									</div>
								</div>
								<div class="user-amount-btn">
									<button type="button" class="btn btn-secondary" v-if="!loading" @click="cancelBonusVerification(bonus.id)" style="cursor: pointer;">{{ $t('general.cancel') }}</button>
									<button class="btn btn-secondary" type="button" v-else><div class="loader-main"></div></button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end -->
		</div>
		<div class="user-logout-btn">
			<a href="#" @click="logout">{{ $t('general.logout') }}</a>
		</div>
	</div>
</template>
<style scoped>

.balance-container {
	display: grid;
	/* grid-template-columns: 66px 93px 42px; */
	/* grid-template-columns: 66px 74px 78px; */
	grid-template-columns: 40px 27px;
	align-items: center;

}
@media screen and (max-width: 400px) {
	.balance-container {
		margin-left: 50px;
	}
	html[dir="rtl"] .balance-container {
		margin-left: unset;
		margin-right: 50px;
	}
}

@media screen and (min-width: 401px) and (max-width: 500px) {
	.balance-container {
		margin-left: 80px;
	}
	html[dir="rtl"] .balance-container {
		margin-left: unset;
		margin-right: 80px;
	}
}
@media screen and (min-width: 501px) and (max-width: 600px) {
	.balance-container {
		margin-left: 100px;
	}
	html[dir="rtl"] .balance-container {
		margin-left: unset;
		margin-right: 100px;
	}
}

@media screen and (min-width: 601px) and (max-width: 700px) {
	.balance-container {
		margin-left: 130px;
	}
	html[dir="rtl"] .balance-container {
		margin-left: unset;
		margin-right: 130px;
	}
}
@media screen and (min-width: 701px) and (max-width: 767px) {
	.balance-container {
		margin-left: 150px;
	}
	html[dir="rtl"] .balance-container {
		margin-left: unset;
		margin-right: 150px;
	}
}
@media screen and (min-width: 768px) and (max-width: 3000px) {
	span.mobile-only {
		display:none;
	}
	.balance-container {
		grid-template-columns: auto;
		margin-left: 50px;
	}
}
@media screen and (max-width: 767px) {
	.popup-alert {
		position: fixed;
		top: 50%;
		left: 0% !important;
		width: 100%;
		z-index: 999;
	}
}

.popup-alert {
	position: fixed;
	top: 50%;
	left: 50%;
	z-index: 999;
}

header.Logged-in .header-inner .login-info .user-profile-top.active .user-dropdown-info .user-amount-info {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr !important;

}

/* .dropdown-eye-icon {
	margin-top: 10px;
	padding-left: 17px;
} */
/*
html[dir="rtl"] .dropdown-eye-icon {
	margin-top: 10px;
	padding-left: unset;
	padding-right: 17px !important;
} */

@media screen and (min-width: 510px) and (max-width: 767px) {
	/* .dropdown-eye-icon {
		padding-left: 170px;
	} */

	/* html[dir="rtl"] .dropdown-eye-icon {
		padding-left: unset;
		padding-right: 170px !important;
	} */
}

@media screen and (min-width: 320px) and (max-width: 509px) {
	/* .dropdown-eye-icon {
		padding-left: 100px;
	}

	html[dir="rtl"] .dropdown-eye-icon {
		padding-left: unset;
		padding-right: 100px !important;
	} */
}

@media screen and (min-width: 768px) {
	/* .dropdown-eye-icon {
		padding-left: 50px;
	}

	html[dir="rtl"] .dropdown-eye-icon {
		padding-left: unset;
		padding-right: 50px !important;
	} */
}

@media screen and (min-width: 768px) {

	.user-dropdown-info .user-amount-info .user-amount-btn a {
		width: 220px !important;
	}

	.user-dropdown-info .user-amount-info .user-amount-btn {
		grid-column-start: 3;
		grid-column-end: auto;

	}
}

.rotate svg{
	transform: rotate(180deg);
	transition: transform 0.3s ease;
}

.rotate-svg {
	animation: spin 1s linear infinite;
	transform-origin: center;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.buttons-flex {
	display: flex;
	justify-content: space-evenly;
	flex-wrap: unset;
}

@media screen and (max-width: 380px) {
	.buttons-flex {
		display: flex;
		flex-wrap: wrap;
		justify-content: unset;
	}
}

@media screen and (max-height: 485px) {
    .user-dropdown-info {
        max-height: 250px; /* Adjust max height for even smaller screens */
		overflow-y: scroll;
    }
}
</style>